import { render, staticRenderFns } from "./MovimientoItem.vue?vue&type=template&id=076f15a2"
import script from "./MovimientoItem.vue?vue&type=script&lang=js"
export * from "./MovimientoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports